var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedSpaceSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 55,
    viewBox: "0 0 79 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9175 22.5206L24.8614 23.2595C24.7553 24.6562 23.3783 25.8949 21.9783 25.8531L21.2377 25.831C19.2302 25.7709 17.4642 24.9985 16.2514 23.6501L10.5584 17.3217C9.41594 16.0515 8.83141 14.3448 8.89704 12.4706L8.93298 11.4459C8.98423 9.98525 10.4527 8.66431 11.9106 8.76744L12.9333 8.83978C14.8039 8.97213 16.4395 9.73338 17.582 11.0035L23.2749 17.3321C24.4878 18.6804 25.0695 20.5181 24.9175 22.5206Z",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89252 25.8538H0.961273V4.07098C0.961273 2.66238 2.10315 1.52067 3.51159 1.52067H6.34221C7.75065 1.52067 8.89252 2.66238 8.89252 4.07098V25.8538Z",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6463 42.7345H77.8357V31.4878C77.8357 33.0376 76.5794 34.2939 75.0294 34.2939H27.7482C26.1982 34.2939 24.9419 33.0376 24.9419 31.4878V25.8533H0.960663V42.7345H15.8977",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8363 28.1623C77.8363 26.1321 76.716 24.2553 74.9083 23.331C73.1796 22.447 70.5113 21.6704 66.4719 21.6704H24.9416V31.4873C24.9416 33.0373 26.1982 34.2938 27.7482 34.2938H75.0297C76.5797 34.2938 77.8363 33.0373 77.8363 31.4873V28.1623Z",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.961273 42.7344V53.9446H6.35424C6.35424 53.9446 7.11893 45.8599 11.1346 42.7344H0.961273Z",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8372 42.7344V53.9446H72.4443C72.4443 53.9446 71.6795 45.8599 67.664 42.7344H77.8372Z",
    stroke: "#344563",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedSpaceSvg);
export default __webpack_public_path__ + "static/media/bedSpaceSvg.392b85f7.svg";
export { ForwardRef as ReactComponent };